import { Nullable, CpsUser } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { currentUserKeys } from '../../queryKeys/currentUser';

export function useGetCurrentUser(): UseQueryResult<Nullable<CpsUser>, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getCurrentUser = async () => {
    if (servicesCtx?.currentUserService) {
      const response = await servicesCtx.currentUserService.getCurrentUser();
      if (!response) {
        return null;
      }
      const currentUser: CpsUser = {
        id: response.id,
        email: response.email,
        displayName: response.displayName,
        indexes: response.indexes
      };
      return currentUser;
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: currentUserKeys.me,
    queryFn: getCurrentUser,
    retry: 0,
    staleTime: Infinity,
    gcTime: 28800000
  });
}
